import { defineMessages } from 'react-intl';

import type { CodeEditorLanguages } from './languages/languages.js';

export const PLACEHOLDER_MESSAGES = defineMessages<CodeEditorLanguages>({
  other: {
    defaultMessage: 'Add code',
    description: 'Default placeholder for code editor when no language is set.',
    id: 'fIr5C8WQPnYfAMr5',
  },
  json: {
    defaultMessage: 'Add JSON',
    description:
      'Default placeholder for code editor when the language is JSON.',
    id: 'XXsHBFWgU7wZSd8V',
  },
  js: {
    defaultMessage: 'Add JavaScript',
    description:
      'Default placeholder for code editor when the language is JavaScript.',
    id: 'fg8x33u8t5tYtlE9',
  },
  jsx: {
    defaultMessage: 'Add JSX',
    description:
      'Default placeholder for code editor when the language is JSX.',
    id: 'PCUD8a2q2mhgGcgg',
  },
  ts: {
    defaultMessage: 'Add TypeScript',
    description:
      'Default placeholder for code editor when the language is TypeScript.',
    id: 'xT9m8P49DpYVR1pg',
  },
  tsx: {
    defaultMessage: 'Add TSX',
    description:
      'Default placeholder for code editor when the language is TSX.',
    id: '9AzZAjitLsfniU2y',
  },
  md: {
    defaultMessage: 'Add Markdown',
    description:
      'Default placeholder for code editor when the language is Markdown.',
    id: 'ZrxrsiqabWfxne/q',
  },
  yaml: {
    defaultMessage: 'Add YAML',
    description:
      'Default placeholder for code editor when the language is YAML.',
    id: '0mIAvvhLoJG6DVyY',
  },
});
